module.exports = __webpack_public_path__ + "img/help_center_icon.7f0ad2bc.svg";